import { Theme } from "@mui/material/styles";

const tiersStyle = {
  card: (theme: Theme) =>
    ({
      padding: 3,
      minHeight: 580,
      border: `3px solid #ee4881`,
      background: "rgba(37, 37, 63, 0.3)",
      borderRadius: 7,
      boxShadow: "0 0 29px 2px rgba(212, 218, 251, 0.5)",
      [theme.breakpoints.down("xl")]: {
        minHeight: 685,
      },
      [theme.breakpoints.down("lg")]: {
        minHeight: 605,
      },
    } as const),
  button: {
    padding: 0,
    backgroundImage: `url(${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/pages/christmasPage/button.png)`,
    backgroundSize: "213px 86px",
    backgroundColor: "inherit",
    backgroundRepeat: "no-repeat",
    boxShadow: "none",
    position: "absolute",
    border: "none",
    bottom: -36,
    right: -47,
    width: 255,
    height: 109,
    "&:hover,&:focus": {
      backgroundColor: "inherit",
      boxShadow: "none",
    },
    "&:hover > h3": {
      transform: "scale(1.1)",
      transition: "all .2s",
    },
  },
  buttonText: {
    marginLeft: -9.375,
  },
} as const;

export default tiersStyle;
